import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { StringFormatter } from '@repo/toolkit/string'
import { format } from 'date-fns'
import { fr } from 'date-fns/locale'
import { Formatters } from 'react-day-picker'

import Typography from '../typography'

export const calendarFormatters = (locale = fr): Partial<Formatters> => ({
  formatWeekdayName: (weekdayName) => (
    <Typography
      variant="label-semibold"
      className="capitalize"
      color={tailwindColors.grey.light.active}
    >
      {StringFormatter.toTitleCase(format(weekdayName, 'EEEEEEE', { locale }).slice(0, 3))}
    </Typography>
  ),
  formatCaption: (date) => {
    return (
      format(date, 'MMMM yyyy', { locale }).charAt(0).toUpperCase() +
      format(date, 'MMMM yyyy', { locale }).slice(1)
    )
  }
})
